import { render, staticRenderFns } from "./ShiftStatus.vue?vue&type=template&id=1ff354f6&"
import script from "./ShiftStatus.vue?vue&type=script&lang=js&"
export * from "./ShiftStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports